// Product data with all details from the original IndyaNet website
export const productsData = {
  'indyanet-edge-small': {
    name: 'IndyaNet Edge Small',
    tagline: 'Unleash Networking Power for Medium Branches',
    image:
      'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/edge%20small%20jpg.jpg/:/',
    description:
      'IndyaNet Ray combines the features of multiple specialty product lines into One single EDGE Product line. Edge is offered in both Physical Appliance and Virtual format. Edge is managed from the same IndyaNet Ray Platform that manages the IndyaNet Ray Switch, IndyaNet Ray Wi-Fi and IndyaNet Ray Endpoint.',
    overview:
      "IndyaNet Ray's cutting-edge convergence solution effortlessly scales to any location, whether it's a remote office, branch, campus, data center, or cloud environment. Our innovative hybrid mesh firewall system is expertly managed through IndyaNet Ray Unified Management, ensuring seamless security across intricate hybrid infrastructures. Powered by the IndyaNet Ray One, our solution offers unparalleled visibility and security in multiple form factors.",
    overview2:
      "IndyaNet Ray's Secure SD-WAN solution delivers exceptional speed, scalability, and adaptability both on-premises and in the cloud. Designed with cloud-first, security-conscious, and global enterprises in mind, IndyaNet Ray Secure SD-WAN also caters to the evolving needs of hybrid workforces. Our Integrated Networking approach employs a single operating system, streamlining SD-WAN, next-generation firewall (NGFW), advanced routing, and Zero Trust Network Access (ZTNA) application gateway capabilities.",
    keyHighlights: [
      '6 x GE RJ45',
      '1 x Console Port',
      '6 x 1G Ports',
      '2 x USB 3.0',
      '1 x Wi-Fi (Optional)',
      '1 x 4G (Optional)',
    ],
    features: [
      { title: 'Acceleration', desc: 'Architecture for improved performance, greater ROI, and reduced power consumption.' },
      { title: 'Secure SD-WAN', desc: 'Optimize performance for SaaS, SD-WAN, and cloud traffic with IndyaNet Ray One.' },
      { title: 'One Console to Manage It All', desc: 'IndyaNet Ray One provides a single cloud management console for all your IndyaNet Ray Product line.' },
      { title: 'Reporting in the Cloud', desc: 'Flexible reporting tools for analyzing and visualizing network data over time.' },
      { title: 'Isolate Infected Systems', desc: 'Automatic threat response to identify and isolate compromised systems on your network.' },
      { title: 'Zero-Day and ML Protection', desc: 'Instantly identify the latest ransomware and unknown threats with machine learning technology.' },
      { title: 'Advanced Threat Protection', desc: 'Instantly identify bots and other advanced threats while defending your network.' },
      { title: 'User Identity', desc: 'User identity-based policies and unique user risk analysis for better network control.' },
      { title: 'Application Control', desc: 'Complete visibility and control over all applications on your network with deep-packet scanning technology.' },
      { title: 'Web Control', desc: 'Full visibility and control over web traffic with flexible enforcement tools.' },
      { title: 'Content Control', desc: 'User-based monitoring and control of keyword content and downloadable content.' },
      { title: 'Business Applications', desc: 'Protect critical applications with next-gen firewall and an enterprise-class web application firewall.' },
    ],
    specifications: [
      { label: 'Interfaces', value: '6 x GE RJ45' },
      { label: 'Firewall Throughput', value: '12 Gbps' },
      { label: 'IPsec VPN Throughput', value: '8.2 Gbps' },
      { label: 'IPS Throughput', value: '2.5 Gbps' },
      { label: 'NGFW Throughput', value: '2.6 Gbps' },
      { label: 'Threat Protection Throughput', value: '2.5 Gbps' },
      { label: 'Concurrent Sessions', value: '4.19 Million' },
      { label: 'New Sessions/Sec', value: '53,150' },
      { label: 'IPSEC VPN Concurrent Tunnels', value: '1000' },
      { label: 'SSL VPN Throughput', value: '700 Mbps' },
      { label: 'Concurrent SSL VPN Tunnel', value: '1000' },
      { label: 'SSL/TLS Inspection', value: '800 Mbps' },
      { label: 'Application Control Throughput', value: '1.4 Gbps' },
      { label: 'I/O Interface', value: '1 x Console Port, 2 x USB 3.0, 1 x VGA, 1 x Reset Button' },
      { label: 'Optional Interfaces', value: '1 x Wi-Fi, 1 x (4G)' },
      { label: 'Wi-Fi (Optional)', value: 'WIFI 6 2 X 2' },
      { label: 'Antenna (For Wi-Fi & Cellular)', value: '2 X External' },
      { label: 'Local Storage', value: '128 GB' },
      { label: 'Form Factor', value: 'Desktop' },
      { label: 'Operational Temperature', value: '0℃ ~ 45℃' },
    ],
  },
  'indyanet-edge-mini': {
    name: 'IndyaNet Edge Mini',
    tagline: 'Cloud-Managed Networking Solution',
    image:
      'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/edge%20mini%20jpg.jpg/:/',
    description:
      'IndyaNet Ray combines the features of multiple specialty product lines into One single EDGE Product line.',
    keyHighlights: [
      '4 × 1G WAN / LAN ports for wired uplinks and local networks',
      'Cellular USB dongle support for 4G/5G backup or failover',
      'Support for Wi-Fi via built-in radio or module',
      'Firewall throughput up to 10 Gbps',
      'Full firewall & security features embedded',
      'No external security appliance needed',
    ],
    sections: [
      {
        title: 'Performance & Capabilities',
        items: [
          'Firewall: up to 10 Gbps throughput',
          'User scale: supports deployment for up to 100 users',
          'All-in-one: combines routing, switching, firewall, SD-WAN, and radio management',
        ],
      },
      {
        title: 'Environmental & Deployment',
        items: [
          'Compact, plug-in form factor — easy to install in branch setups',
          'Designed for low maintenance and quick deployment',
          'Ideal for small sites, kiosks, remote offices, retail stores, banking branches, etc.',
        ],
      },
      {
        title: 'Use Cases & Industry Applications',
        items: [
          'Small branch offices & micro sites',
          'Retail stores, kiosks, POS terminals',
          'Banking / ATMs / branch networks',
          'Remote connectivity in hybrid WAN environments',
        ],
      },
    ],
    benefits: [
      { feature: 'Cloud-managed via IndyaNet ONE', benefit: 'Single pane of glass for monitoring & control' },
      { feature: 'All-in-one architecture', benefit: 'Combines networking + security + radio in one unit' },
      { feature: 'Multi-WAN support & failover', benefit: 'Stay connected even during link outages' },
      { feature: 'Built-in firewall & security features', benefit: 'No need for separate security appliance' },
      { feature: 'Plug-and-play deployment', benefit: 'Rapid rollout across branches' },
      { feature: 'Scalable to 100 users', benefit: 'Suitable for many small to medium deployments' },
    ],
  },
  'indyanet-edge-atom': {
    name: 'IndyaNet Edge Atom',
    tagline: 'M2M Network Solutions for Enterprise Connectivity',
    image:
      'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/Edge%20atom%20jpg.jpg/:/',
    description:
      'IndyaNet Ray combines the features of multiple specialty product lines into One single EDGE Product line.',
    keyHighlights: [
      '5 × 1G Ethernet ports (WAN / LAN)',
      'Dual SIM slot (active / active) for 4G/5G cellular links',
      '2×2 MIMO cellular support',
      'Up to 3000 Mbps throughput',
      'Wi-Fi 5 capabilities (if module equipped)',
      'Desktop form factor for easy deployment',
    ],
    sections: [
      {
        title: 'Performance & Capabilities',
        items: [
          'Throughput: 3000 Mbps',
          'WAN / LAN ports: 5 ports (1G)',
          'Cellular resilience: 2 SIMs (active-active) with 4G/5G failover',
          'MIMO Support: 2×2 for better link reliability and speed',
          'Wi-Fi support: Wi-Fi 5 (if module or version supports)',
        ],
      },
      {
        title: 'Environmental & Deployment',
        items: [
          'Desktop form factor — compact and suited for branch offices',
          'Designed for plug-and-play deployment with minimal onsite configuration',
          'Ideal for branch offices, retail outlets, kiosks, financial outlets, remote sites',
        ],
      },
    ],
  },
  'indyanet-edge-1l': {
    name: 'IndyaNet Edge 1L',
    tagline: 'For Medium Branches, Desktop Form Factor',
    image:
      'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/Edge%201l.jpg/:/',
    description:
      'The IndyaNet Edge 1L is designed for medium-sized branch offices, offering robust networking capabilities with a desktop form factor for easy deployment.',
    keyHighlights: [
      'Multiple GE RJ45 ports for flexible connectivity',
      'Console port for direct management',
      'USB 3.0 ports for additional connectivity',
      'Wi-Fi capability (optional)',
      '4G cellular backup (optional)',
      'Desktop form factor',
    ],
    sections: [
      {
        title: 'Performance & Capabilities',
        items: [
          'High firewall throughput for medium-sized branches',
          'IPsec VPN support for secure connectivity',
          'Application-aware routing',
          'Centralized management via IndyaNet Ray One',
        ],
      },
      {
        title: 'Environmental & Deployment',
        items: [
          'Desktop form factor — easy to install',
          'Plug-and-play deployment',
          'Ideal for medium branches and offices',
          'Low power consumption',
        ],
      },
    ],
  },
  'multi-wan-gigabit-vpn': {
    name: 'Multi-WAN Gigabit VPN Router',
    tagline: 'GWN7001, GWN7002, GWN7003',
    image:
      'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/Multiwan%20gigabit.jpg/:/',
    description:
      'The Grandstream GWN Series Multi-WAN Gigabit VPN Routers (GWN7001, GWN7002, GWN7003) deliver powerful networking capabilities with intelligent load balancing and failover for businesses of all sizes.',
    keyHighlights: [
      'Multi-WAN support with intelligent load balancing',
      'Built-in VPN server (IPSec, OpenVPN, L2TP)',
      'Gigabit Ethernet ports for high-speed connectivity',
      'Advanced QoS and traffic shaping',
      'Centralized cloud management',
      'Enterprise-grade security features',
    ],
    sections: [
      {
        title: 'Performance & Capabilities',
        items: [
          'Load Balancing: Intelligently distributes network traffic across multiple paths',
          'Traffic Steering: Advanced control over various types of traffic',
          'Bandwidth Policy Management: Instant access to improved WAN connections',
          'Failover Protection: Automatic switchover for uninterrupted connectivity',
        ],
      },
      {
        title: 'Key Features',
        items: [
          'Support for multiple ISP connections',
          'Optimal bandwidth utilization',
          'Resilience against single point of failure',
          'Customizable network policies',
          'Real-time monitoring and analytics',
        ],
      },
      {
        title: 'Use Cases',
        items: [
          'Multi-site enterprise networks',
          'Branch office connectivity',
          'Remote worker VPN access',
          'Backup and redundancy solutions',
        ],
      },
    ],
  },

  //ALL 6 SWITCH PRODUCTS HERE

  'gwn7711': {
  name: 'GWN7711',
  tagline: 'Layer 2 Lite Managed Network Switch',
  image: 'https://www.grandstream.com/hubfs/GWN7711(P)_2.png',
  description:
    'The GWN7711 is a Layer 2 Lite managed network switch designed for small-to-medium businesses looking for scalable and cloud-manageable networking.',
  keyHighlights: [
    '8 Gigabit Ethernet Ports',
    'Cloud Manageable',
    'Loop Detection Support',
    'IGMP Snooping',
    'Built-in QoS',
    'Smart Network Management',
  ],
},

'gwn7711p': {
  name: 'GWN7711P',
  tagline: 'Layer 2 Lite Managed PoE Network Switch',
  image: 'https://www.grandstream.com/hubfs/GWN7711(P)_3.png',
  description:
    'The GWN7711P provides Layer 2 Lite management with integrated PoE support for powering IP phones, cameras, and wireless access points.',
  keyHighlights: [
    '8 Gigabit Ethernet Ports',
    'PoE / PoE+ Support',
    'Cloud Manageable',
    'Smart Power Control',
    'IGMP Snooping',
    'Built-in QoS',
  ],
},

'gwn7700-series': {
  name: 'GWN7700 Series',
  tagline: 'Unmanaged Gigabit Network Switch',
  image: 'https://www.grandstream.com/hubfs/GWN7702%2c7702P%2c7703%2c7706%20Combo.png',
  description:
    'The GWN7700 Series delivers high-speed Gigabit connectivity with a simple plug-and-play deployment model for businesses of all sizes.',
  keyHighlights: [
    '5/8/16/24/48 Port Options',
    'Gigabit Connectivity',
    'Plug and Play Deployment',
    'Green Technology',
    'Auto MDI/MDIX',
    'QoS Support',
  ],
},

'gwn7800-series': {
  name: 'GWN7800 Series',
  tagline: 'Layer 2+ Managed Network Switch',
  image: 'https://www.grandstream.com/hubfs/GWN7800%20Series%20Website%20Pic%207.png',
  description:
    'The GWN7800 Series provides Layer 2+ management features with enhanced security, scalability and intelligent cloud management.',
  keyHighlights: [
    '8/16/24 Gigabit Ports',
    'Layer 2+ Switching',
    'Cloud Management',
    'Advanced Security',
    'PoE Models Available',
    'Built-in QoS',
  ],
},

'gwn7806p': {
  name: 'GWN7806(P)',
  tagline: 'Enterprise Grade Layer 2+ Managed Switch',
  image: 'https://www.grandstream.com/hubfs/Product%20Images/GWN7806/GWN7806%20Website%20Image%20-%201.png',
  description:
    'The GWN7806(P) is a high-performance Layer 2+ managed switch with enterprise-grade reliability and advanced networking capabilities.',
  keyHighlights: [
    '48 Gigabit Ethernet Ports',
    '6 x 10G SFP+ Ports',
    'PoE Models Available',
    'Enterprise Security',
    'Stacking Support',
    'Advanced QoS',
  ],
},

'gwn7810-series': {
  name: 'GWN7810 Series',
  tagline: 'Enterprise Layer 3 Managed Network Switch',
  image: 'https://www.grandstream.com/hubfs/GWN781X%204%20Website%20Upload.png',
  description:
    'The GWN7810 Series is a Layer 3 managed switch designed for enterprise environments requiring high-performance routing and switching.',
  keyHighlights: [
    'Layer 3 Routing',
    '10 Gigabit SFP+ Ports',
    'Advanced Security',
    '8/16/24 Gigabit Ports',
    'Cloud Monitoring',
    'QoS & Traffic Prioritization',
  ],
},

'network-rack': {
  name: 'Network Rack',
  tagline: '2U / 4U Wall Mount Network Rack',
  image: 'https://m.media-amazon.com/images/I/51D2sy9ZnRL._SX450_.jpg',
  description:
    'The Network Rack is a compact wall-mounted enclosure designed to securely house networking devices such as DVRs, NVRs, Wi-Fi routers, switches, and patch panels. Available in both 2U and 4U variants, it provides excellent protection, cable organization, and easy equipment access for homes, offices, retail stores, and surveillance installations.',
  keyHighlights: [
    'Available in 2U & 4U Sizes',
    'Transparent Front Glass Door',
    'Wall Mount Design',
    'Built-in 3 Power Socket',
    'Durable Metal Construction',
    'Ideal for DVR, NVR & Routers',
  ],
  specifications: [
    { label: 'Available Sizes', value: '2U / 4U' },
    { label: 'Compatible Devices', value: 'CCTV DVR, NVR, Router, Switch' },
    { label: 'Mounting Type', value: 'Wall Mount' },
    { label: 'Door Type', value: 'Transparent Glass Door' },
    { label: 'Material', value: 'Powder Coated Metal' },
    { label: 'Power Socket', value: '3 Socket Power Strip' },
  ],
},

'cat6-utp-patch-panel': {
  name: 'CAT6 UTP Patch Panel',
  tagline: '8 / 16 / 24 Port Patch Panel',
  image: 'https://iconicitstore.com/wp-content/uploads/2021/12/d-link-cat6-utp-24-port-loaded-patch-panel-cat6-24-port-panel-500x500-1.jpg',
  description:
    'The D-Link CAT6 UTP Patch Panel is designed for structured cabling installations, offering reliable cable termination and organized network management for enterprise, surveillance, and office environments.',
  keyHighlights: [
    '8 / 16 / 24 Port Options',
    'CAT6 UTP Standard',
    'Supports Gigabit Ethernet',
    '19-inch Rack Mount',
    '110 IDC Punch Down',
    'Supports T568A / T568B',
  ],
  specifications: [
    { label: 'Ports', value: '8 / 16 / 24' },
    { label: 'Category', value: 'CAT6 UTP' },
    { label: 'Speed', value: '10/100/1000 Mbps' },
    { label: 'Rack Size', value: '19 Inch' },
    { label: 'Cable Support', value: '22–26 AWG' },
    { label: 'Termination', value: '110 IDC' },
  ],
},

'face-plate': {
  name: 'Face Plate',
  tagline: 'Network Face Plate with Shutter',
  image: 'https://its.dlink.co.in/assets/ppic_1509456303.png',
  description:
    'The D-Link Face Plate provides a clean and professional network outlet solution for structured cabling installations. Compatible with standard Keystone Jacks and available in multiple port configurations.',
  keyHighlights: [
    'Built-in Dust Shutter',
    'Label Holder Included',
    'Single, Dual & Quad Port Options',
    'Compatible with Keystone Jacks',
    'Professional Finish',
    'Easy Installation',
  ],
  specifications: [
    { label: 'Material', value: 'ABS Plastic' },
    { label: 'Dust Cover', value: 'ABS White' },
    { label: 'ID Plate', value: 'Transparent PC' },
    { label: 'Label Holder', value: 'Included' },
    { label: 'Screw', value: 'M3.5 × L25mm' },
    { label: 'Color', value: 'White' },
  ],
},

'rj45-connector-plug': {
  name: 'RJ45 Connector Plug',
  tagline: 'RJ45 Modular Plug Pack of 100',
  image: 'https://m.media-amazon.com/images/I/41cyX0hwAjS.jpg',
  description:
    'The D-Link RJ45 Connector Plug is designed for reliable Ethernet cable termination, providing secure connectivity for CAT5e and CAT6 network installations.',
  keyHighlights: [
    'RJ45 Connector',
    'Pack of 100',
    'High Durability',
    'Reliable Connection',
    'Easy Crimping',
    'Professional Networking',
  ],
  specifications: [
    { label: 'Connector Type', value: 'RJ45' },
    { label: 'Pack Size', value: '100 Pieces' },
    { label: 'Compatibility', value: 'CAT5e / CAT6' },
    { label: 'Application', value: 'LAN Networking' },
    { label: 'Installation', value: 'Crimp Type' },
    { label: 'Brand', value: 'D-Link' },
  ],
},

'cat6-networking-cable': {
  name: 'CAT6 Networking Cable',
  tagline: 'High-Speed Ethernet Cable',
  image: 'https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcSWfYMu2TdO6e4_Ldf-J4GpvS02omrcGrNfllyCSGP2QYbQmArmfalviIytevW2qAwJjXzxsMihTM2Cd-rfmghypos6iIcg',
  description:
    'The D-Link CAT6 Networking Cable delivers high-speed Gigabit Ethernet connectivity with superior performance, making it ideal for structured cabling systems, offices, data centers, and surveillance networks.',
  keyHighlights: [
    'CAT6 Standard',
    'Gigabit Ethernet',
    '24 AWG Copper',
    'High-Speed Data Transfer',
    'Reliable Performance',
    'Long Distance Support',
  ],
  specifications: [
    { label: 'Cable Type', value: 'CAT6 Ethernet Cable' },
    { label: 'Speed', value: '1000Base-T' },
    { label: 'Conductor', value: '24 AWG' },
    { label: 'Compatible Devices', value: 'Router, Switch, Modem, PC' },
    { label: 'Application', value: 'LAN Networking' },
    { label: 'Brand', value: 'D-Link' },
  ],
},

'cat6-patch-cord': {
  name: 'CAT6 Patch Cord',
  tagline: 'RJ45 Ethernet Patch Cable',
  image: 'https://m.media-amazon.com/images/I/61wy4EqaA9L._SY450_.jpg',
  description:
    'The D-Link CAT6 Patch Cord is a factory-terminated Ethernet cable designed for reliable high-speed network connectivity between switches, routers, patch panels, computers, and other network devices.',
  keyHighlights: [
    'RJ45 Connector',
    'CAT6 Cable',
    'High-Speed Ethernet',
    'Snagless Design',
    '24 AWG Conductor',
    'Plug & Play',
  ],
  specifications: [
    { label: 'Cable Type', value: 'CAT6 Patch Cord' },
    { label: 'Connector', value: 'RJ45 to RJ45' },
    { label: 'Conductor', value: '24 AWG' },
    { label: 'Cable Style', value: 'Snagless' },
    { label: 'Speed', value: '1000Base-T Ethernet' },
    { label: 'Compatible Devices', value: 'Router, Switch, PC, Patch Panel' },
  ],
},

'cp-plus-8ch-nvr': {
  name: 'CP Plus 8 Channel Network Video Recorder',
  tagline: 'CP-UNR-4K2081-V4',
  image: 'https://m.media-amazon.com/images/I/61gek7+PdGL._AC_UF1000,1000_QL80_.jpg',
  description:
    'The CP Plus CP-UNR-4K2081-V4 is an 8 Channel 4K Network Video Recorder designed for professional IP surveillance systems with AI features and high bandwidth support.',
  keyHighlights: [
    '8 Channel NVR',
    '4K Recording',
    'Supports AI Features',
    'Up to 20TB HDD',
    'H.265 / H.264 Compression',
    'Remote Monitoring',
  ],
  specifications: [
    { label: 'Channels', value: '8 Channel' },
    { label: 'Recording Resolution', value: '4K Ultra HD' },
    { label: 'Video Compression', value: 'H.265 / H.264 / MJPEG' },
    { label: 'Storage', value: '1 SATA HDD up to 20TB' },
    { label: 'Ports', value: 'HDMI, VGA, USB, RJ45' },
    { label: 'Mobile App', value: 'iCMOB / gCMOB' },
  ],
},

'cp-plus-8ch-dvr': {
  name: 'CP Plus 8 Channel Digital Video Recorder',
  tagline: 'CP-UVR-0801F1V-I',
  image: 'https://cpplusworld.com/prodassets/product/small/79c341f5-076e-46d7-84ac-f0f57ed37c53.png',
  description:
    'The CP Plus CP-UVR-0801F1V-I is an 8 Channel Full HD Digital Video Recorder supporting HDCVI, AHD, TVI, CVBS and IP cameras.',
  keyHighlights: [
    '8 Channel DVR',
    '1080P Recording',
    'Supports IP Cameras',
    'H.265 Compression',
    'AI Features',
    'Mobile Monitoring',
  ],
  specifications: [
    { label: 'Channels', value: '8 Channel' },
    { label: 'Resolution', value: '1080P Full HD' },
    { label: 'Video Input', value: 'HDCVI / AHD / TVI / CVBS / IP' },
    { label: 'Compression', value: 'H.265 / H.264' },
    { label: 'Mobile App', value: 'iCMOB / gCMOB' },
    { label: 'CMS', value: 'KVMS Pro Lite' },
  ],
},

'cp-plus-3mp-wifi-camera': {
  name: 'CP PLUS 3MP Smart Wi-Fi CCTV Camera',
  tagline: 'CP-E31Q',
  image: 'https://m.media-amazon.com/images/I/51e58RA-akL._SX679_.jpg',
  description:
    'Smart Wi-Fi security camera with 3MP resolution, 360° coverage, motion tracking and two-way audio.',
  keyHighlights: [
    '3MP Resolution',
    '360° Pan & Tilt',
    'Motion Tracking',
    '2-Way Audio',
    'Night Vision',
    'Cloud & SD Card Support',
  ],
  specifications: [
    { label: 'Resolution', value: '3MP' },
    { label: 'Viewing Angle', value: '360° Coverage' },
    { label: 'Night Vision', value: '15m IR' },
    { label: 'Storage', value: 'Cloud & MicroSD Card' },
    { label: 'Connectivity', value: 'Wi-Fi' },
    { label: 'Model', value: 'CP-E31Q' },
  ],
},

'rj45-network-crimping-tool': {
  name: 'RJ45 Network Cable Crimping Tool',
  tagline: 'Heavy Duty Ethernet Crimper',
  image: 'https://m.media-amazon.com/images/I/61w0I3nx9yL._SX569_.jpg',
  description:
    'Professional multi-functional RJ45 crimping tool for cutting, stripping and crimping Ethernet cables.',
  keyHighlights: [
    'RJ45 Crimp Tool',
    'Wire Cutter',
    'Cable Stripper',
    'Heavy Duty',
    'Ergonomic Handle',
    'Professional Grade',
  ],
  specifications: [
    { label: 'Connector Type', value: 'RJ45' },
    { label: 'Functions', value: 'Cut, Strip & Crimp' },
    { label: 'Handle', value: 'Ergonomic Grip' },
    { label: 'Compatibility', value: 'CAT5 / CAT5e / CAT6' },
    { label: 'Material', value: 'Steel Body' },
    { label: 'Application', value: 'Network Installation' },
  ],
},

'cp-plus-full-hd-security-camera': {
  name: 'CP PLUS Full HD 1080P Security Camera',
  tagline: 'Indoor Security Camera with Clear Night Vision',
  image: 'https://rukminim2.flixcart.com/image/1366/1366/xif0q/home-security-camera/0/t/b/1-cp-usc-da24l2-indoor-security-camera-cp-plus-original-imahhxwmtxhsbhpn.jpeg?q=90',
  description:
    'The CP PLUS Full HD 1080P Security Camera delivers high-quality indoor surveillance with clear day and night monitoring. Designed for homes, offices, retail stores, and commercial spaces, it offers reliable Full HD video recording, infrared night vision, and easy installation for 24×7 security.',
  keyHighlights: [
    'Full HD 1080P Resolution',
    'Indoor Security Camera',
    'Clear Night Vision',
    '20m IR Range',
    '1 Channel Support',
    'Reliable 24×7 Monitoring',
  ],
  specifications: [
    { label: 'Camera Type', value: 'Indoor Security Camera' },
    { label: 'Resolution', value: '1080P Full HD (2.4MP)' },
    { label: 'Night Vision', value: 'Infrared up to 20 Meters' },
    { label: 'Lens', value: '3.6mm Fixed Lens' },
    { label: 'Video Output', value: 'HD / SD Analog Output' },
    { label: 'Technology', value: 'Day/Night (ICR), DWDR, 2D-DNR' },
    { label: 'Power Supply', value: 'DC 12V' },
    { label: 'Application', value: 'Home, Office, Shop & Indoor Surveillance' },
  ],
},

'lan-cable-tester-wire-tracker': {
  name: 'LAN Cable Tester with Wire Tracker',
  tagline: 'RJ11 / RJ45 Cable Tester',
  image: 'https://m.media-amazon.com/images/I/71ky4z1FoYL._SX466_.jpg',
  description:
    'Professional cable tester and wire tracker for Ethernet and telephone cable installations.',
  keyHighlights: [
    'Wire Tracker',
    'RJ11 / RJ45 Support',
    'LAN Cable Tester',
    'Telephone Line Tester',
    'LED Indicators',
    'Portable Design',
  ],
  specifications: [
    { label: 'Cable Support', value: 'RJ11 / RJ45' },
    { label: 'Functions', value: 'Cable Test & Wire Tracking' },
    { label: 'Power', value: '2 × 9V Battery' },
    { label: 'Application', value: 'LAN & Telephone Network' },
    { label: 'Weight', value: '380 g' },
    { label: 'Model', value: 'Wire Tracker' },
  ],
},

};
